import { render, staticRenderFns } from "./SetExternalIdModal.vue?vue&type=template&id=495673e8&"
import script from "./SetExternalIdModal.vue?vue&type=script&lang=ts&"
export * from "./SetExternalIdModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports